import React from "react";
import PuzzlePromotionPanel from "../../pzl_common/stats/PuzzlePromotionPanel";
import StatsWordWheelService from "../../../services/StatsWordWheelService";

const EMAIL_TYPES = [
    { value: "word_wheel_quest_daily", label: "Word Wheel Quest updates" },
];

export default function WordWheelPromotionPanel({ language }) {
    return (
        <PuzzlePromotionPanel
            language={language}
            storageKeyPrefix="admin.word_wheel.promotion"
            fetchUsers={StatsWordWheelService.promotionUsers}
            defaultAppId="word_wheel_quest"
            defaultAppName="Word Wheel Quest"
            emailTypes={EMAIL_TYPES}
            emptyLabel="No Word Wheel Quest app players."
            description="Signed-in Word Wheel Quest app players with play records. Name / Email shows the display name and address separately. Email share: Shared is a personal address, Apple relay is Sign in with Apple Hide My Email (@privaterelay.appleid.com — you can still see that relay address). Sorted by last play (newest first). Select players to send a promotion email. Click a name to open the account."
            dialogHint="Compose and send from Advertisement → Promotion. Create new, then select Word Wheel Quest to load the 2.0.1 update template. Recipient history is in system_log (source PromotionEmail)."
        />
    );
}
